const Channel = Object.freeze({
  Unknown: "Unknown",
  App: "App",
  FixitNo: "FixitNo",
  HomePage: "HomePage",
  Salondata: "Salondata",
  Nettbutik: "Nettbutik",
});

export default Channel;
